// @flow

import * as React from 'react';
import BrandIcon from 'sail/BrandIcon';
import type {BrandIconType} from 'sail/BrandIcon/types';

type PaymentMethodIconProps = {|
  type: BrandIconType,
  size?: string,
  className?: string,
|};

const SIZE_MAP = {
  small: 16,
  medium: 20,
  large: 32,
  xlarge: 64,
};

export const PaymentMethodIcon = ({
  type,
  size = 'medium',
  className,
}: PaymentMethodIconProps) => {
  return (
    <BrandIcon icon={type} size={SIZE_MAP[size] || 32} className={className} />
  );
};
